import angular from 'angular';
import { IRotatividadeGrupo, IRotatividadeSecao } from '../rotatividade.service';

const NIVEIS = ['estabelecimento', 'lotacao', 'cargo'];
const MASCARA = '********';

/**
 * Grid de uma seção (Admissões ou Rescisões) do Relatório de Rotatividade: a
 * empresa como faixa de destaque, o grupo do segundo nível como linha de título
 * e os totais no fim de cada grupo, de cada empresa e da seção — o mesmo
 * desenho do PDF.
 */
export class RotatividadeGridController {
    static $inject = ['$filter'];

    public secao: IRotatividadeSecao | undefined;
    public aba: 'admissoes' | 'rescisoes';
    public agrupamento: string;
    public exibirtotais: boolean;
    public carregando: boolean;
    public ordenacao: string;
    public onOrdenar: (args: { campo: string }) => void;

    constructor(public $filter: angular.IFilterService) { }

    agrupado(): boolean {
        return NIVEIS.indexOf(this.agrupamento) !== -1;
    }

    /** A coluna do nível de agrupamento sai da tabela: ela vira o título do grupo. */
    mostraColuna(coluna: string): boolean {
        return this.agrupamento !== coluna;
    }

    numColunas(): number {
        return this.agrupado() ? 7 : 8;
    }

    campoData(): string {
        return this.aba === 'rescisoes' ? 'datarescisao' : 'dataadmissao';
    }

    rotuloData(): string {
        return this.aba === 'rescisoes' ? 'Data de rescisão' : 'Data de admissão';
    }

    /**
     * Admissão mostra o salário fixo; rescisão, o valor líquido da rescisão,
     * como o relatório mostrava antes. Os totais já vêm somados pelo backend
     * com o mesmo campo.
     */
    rotuloValor(): string {
        return this.aba === 'rescisoes' ? 'Valor líquido' : 'Salário fixo';
    }

    valor(trabalhador: any): number | string | null {
        return this.aba === 'rescisoes' ? trabalhador.valorliquidorescisao : trabalhador.salariofixo;
    }

    quantidadeTexto(quantidade: number): string {
        const [singular, plural] = this.aba === 'rescisoes' ? ['rescisão', 'rescisões'] : ['admissão', 'admissões'];
        return `${quantidade} ${quantidade === 1 ? singular : plural}`;
    }

    rotuloTotalGrupo(grupo: IRotatividadeGrupo): string {
        return `Total ${(grupo.rotulo || '').toLowerCase()} ${grupo.nome}`;
    }

    rotuloTotalGeral(): string {
        return `Total geral de ${this.aba === 'rescisoes' ? 'rescisões' : 'admissões'} no período`;
    }

    mensagemVazia(): string {
        return `Nenhuma ${this.aba === 'rescisoes' ? 'rescisão' : 'admissão'} no período para os filtros escolhidos.`;
    }

    /**
     * Valor vazio quando não há o que mostrar (usuário sem permissão de ver
     * salário); a máscara de gestor passa intacta.
     */
    formataValor(valor: number | string | null | undefined): string {
        if (valor === null || valor === undefined || valor === '') {
            return '';
        }
        if (valor === MASCARA) {
            return MASCARA;
        }
        return this.$filter('currency')(Number(valor), 'R$ ', 2);
    }

    ordenar(campo: string): void {
        this.onOrdenar({ campo });
    }
}
